import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Flex } from "./Flex";
/**
 * @trackcomponent
 */ export var DesktopRowMobileColumn = function(props) {
    return /*#__PURE__*/ _jsx(Flex, _object_spread_props(_object_spread({}, props), {
        direction: {
            mobileAndAbove: "column",
            tabletAndAbove: "row"
        }
    }));
};
